import React from 'react';

import { Box, Typography, useTheme } from '@mui/material';

export type PercentWidgetType = {
    label: string;
    values: Array<number>;
};

export const PercentWidget: React.FunctionComponent<PercentWidgetType> = function ({
    label,
    values,
}: PercentWidgetType) {
    const theme = useTheme();
    const total = values.reduce((accumulator, currentValue) => accumulator + currentValue, 0);

    return (
        <Box
            sx={{
                width: '100%',
                backgroundColor: 'text.gris005',
                padding: '20px 40px 20px 60px',
                border: '1px solid',
                borderLeftWidth: '6px',
                borderRadius: '4px',
                color: theme.palette.text.secondary,
                borderColor: 'lime',
            }}
        >
            <Typography>
                {label} : {Number.isNaN(total) ? '0' : total} %
            </Typography>
        </Box>
    );
};
